import React from 'react'
import ReportSummaryCards from './ReportSummaryCards'
import ReportPerformance from './ReportPerformance'
import ReportCharts from './ReportCharts'
import ReportHistoryTable from './ReportHistoryTable'

export default function OverviewPage(props) {
  return (
    <>
      <ReportSummaryCards {...props} />
      <ReportPerformance {...props} />
      <ReportCharts {...props} />
      {/* <ReportHistoryTable {...props} /> */}
    </>
  )
}
